import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

/** Factory de guard por rol. `roleGuard(['ADMIN_FLEET'])`. */
export function roleGuard(allowed: string[]): CanActivateFn {
  return () => {
    const role = inject(AuthService).role();
    return role !== null && allowed.includes(role);
  };
}
